// extracted by mini-css-extract-plugin
export default {"importPage":"F3H4u6Ga","content":"jZU2eoEZ","uploadBox":"VqajfxeV","fileName":"UkpyQzwo","importButton":"Re6UQzfA","message":"HT7mDoxU"};